import { getStorage, ref, getDownloadURL, listAll } from 'firebase/storage';
import firebase from './firebase';

const storage = getStorage(firebase);

// Function to get image URL from Firebase Storage
export const getImageUrl = async (path) => {
  try {
    const imageRef = ref(storage, path);
    const url = await getDownloadURL(imageRef);
    return url;
  } catch (error) {
    console.error('Error getting image URL:', error);
    return null;
  }
};

// Function to get multiple image URLs
export const getImageUrls = async (paths) => {
  try {
    const urls = await Promise.all(
      paths.map(async (path) => {
        const imageRef = ref(storage, path);
        return await getDownloadURL(imageRef);
      })
    );
    return urls;
  } catch (error) {
    console.error('Error getting image URLs:', error);
    return [];
  }
};

// Function to list all images in a folder
export const listImagesInFolder = async (folderPath) => {
  try {
    const folderRef = ref(storage, folderPath);
    const result = await listAll(folderRef);
    return result.items.map(item => item.fullPath);
  } catch (error) {
    console.error('Error listing images:', error);
    return [];
  }
};

// Function to get book cover image URL
export const getBookCoverUrl = async (bookId) => {
  return getImageUrl(`books/covers/${bookId}.jpg`);
};

// Function to get user profile image URL
export const getUserProfileImageUrl = async (userId) => {
  return getImageUrl(`users/${userId}/profile.jpg`);
};

// Function to get all book cover URLs
export const getAllBookCoverUrls = async () => {
  const bookCovers = await listImagesInFolder('books/covers');
  return getImageUrls(bookCovers);
};

// Function to get all user profile image URLs
export const getAllUserProfileImageUrls = async () => {
  const userProfiles = await listImagesInFolder('users');
  return getImageUrls(userProfiles);
}; 